import dynamic from 'next/dynamic';
import React, { useContext, useEffect, useState } from 'react';
import { connect } from 'react-redux';
import EditorialTeamContainer from '../../components/editorial-team/EditorialTeamContainer';
import ThemeContext from '../../providers/ThemeProvider';
import { getServerSideEssentials } from '../../redux/actions/ssr';
import { wrapper } from '../../redux/store/store';

const EditorialTeam = ({ data, errorCode }) => {
  const theme = useContext(ThemeContext);
  const [pageNotFound, setPageNotFound] = useState(false);

  useEffect(() => {
    if (errorCode && document) {
      setPageNotFound(true);
    }
  }, [errorCode]);

  if (pageNotFound) {
    const DynamicComponent = dynamic(() =>
      import('../../components/errors/Form404'),
    );

    return <DynamicComponent statusCode={404} />;
  }

  return (
    <>
      <div className="rel-container">
        <div className="container">
          <EditorialTeamContainer />
        </div>
      </div>
      <style jsx>{`
        .rel-container {
          position: relative;
        }
        .container {
          margin-top: 0;
          background: linear-gradient(180deg, #f2f2f2 0, #fff);
        }

        @media (min-width: ${theme.breakpoints.smUp}) {
          .container {
            margin-top: 20px;
            margin-bottom: 20px;
          }
        }
      `}</style>
    </>
  );
};

export const getServerSideProps = wrapper.getServerSideProps(
  async ({ req, store }) => {
    await store.dispatch(getServerSideEssentials(req.url)).catch((error) => {
      console.log(`getServerSideEssentials error: ${error}`);
    });
  },
);

export default connect()(EditorialTeam);
